export default [
  {
    title: "งานประจำ",
    icon: "mdi-wrench",
    sub: [
      {
        text: "โรงเรียนของคุณ",
        icon: "mdi-home",
        key: "menu.dashbord",
        link: "/",
        allow: ["Super Admin", "School Admin", "Director"]
      },
      {
        text: "ห้องเรียนของคุณ",
        icon: "mdi-account-settings",
        key: "menu.your-class",
        link: "/teacher-dashboard",
        allow: ["Teacher", "Assistant Teacher"]
      }
    ]
  },
  {
    title: "นักเรียนและห้องเรียน",
    icon: "mdi-wrench",
    sub: [
      {
        text: "รายชื่อนักเรียน",
        icon: "mdi-hail",
        key: "menu.students",
        link: "/students",
        allow: [
          "Super Admin",
          "School Admin",
          "Director",
          "Teacher",
          "Assistant Teacher"
        ]
      },
      {
        text: "รายชื่อห้องเรียน",
        icon: "mdi-google-classroom",
        key: "menu.classrooms",
        link: "/classrooms",
        allow: ["Super Admin", "School Admin", "Director"]
      },
      {
        text: "นำเข้ารายชื่อนักเรียน",
        icon: "mdi-account-multiple-plus",
        key: "menu.import-student",
        link: "/new/students",
        allow: ["Super Admin", "School Admin"]
      },
      {
        text: "จัดห้องเรียน",
        icon: "mdi-file-move-outline",
        key: "menu.move-classrooms",
        link: "/manage/classrooms",
        allow: ["Super Admin", "School Admin"]
      }
    ]
  },
  {
    title: "รายงาน",
    icon: "mdi-wrench",
    sub: [
      {
        text: "ห้องเรียน",
        icon: "mdi-chart-bar-stacked",
        key: "menu.reports",
        link: "/reports",
        allow: [
          "Super Admin",
          "School Admin",
          "Director",
          "Teacher",
          "Assistant Teacher"
        ]
      }
    ]
  },
  {
    title: "ตั้งค่า",
    icon: "mdi-wrench",
    sub: [
      {
        text: "ตั้งค่าโรงเรียน",
        icon: "mdi-wrench",
        key: "menu.settings",
        link: "/settings",
        allow: ["Super Admin", "School Admin"]
      },
      {
        text: "ปฏิทินการศึกษา",
        icon: "mdi-av-timer",
        key: "menu.schoolyear",
        link: "/terms",
        allow: [
          "Super Admin",
          "School Admin",
          "Director",
          "Teacher",
          "Assistant Teacher"
        ]
      },
      {
        text: "บุคลากร",
        icon: "mdi-account-tie",
        key: "menu.user",
        link: "/users",
        allow: [
          "Super Admin",
          "School Admin",
          "Director",
          "Teacher",
          "Assistant Teacher"
        ]
      },

      {
        text: "แบบประเมินพัฒนาการ",
        icon: "mdi-clipboard-list-outline",
        key: "menu.development-form",
        link: "/create/development-form",
        allow: [
          "Super Admin",
          "School Admin",
          "Director",
          "Teacher",
          "Assistant Teacher"
        ]
      }
    ]
  }
];
